import { createSlice } from "@reduxjs/toolkit";
import { signIn, slackSignIn, fetchMe, switchOrganization } from "./auth.thunk";

const initialState = {
  error: null,
  success: null,
  loading: false,
  isLoggedIn: false,
  token: null,
  admin: null,
  // The organization the admin is acting in ({ id, name, slug }). Platform
  // admins can switch it; actingOrganizationId is then sent with every request.
  organization: null,
  actingOrganizationId: null,
  permissions: null,
  team: null,
  channel: null,
  admin_teams_channels: [],
};

const onSignedIn = (state, { payload }) => {
  state.error = null;
  state.success = true;
  state.token = payload.token;
  state.isLoggedIn = true;
  state.loading = false;
  state.admin = payload.admin;
  state.organization = payload.organization;
  state.actingOrganizationId = null;
  state.permissions = payload.permissions;
  state.team = payload.team;
  state.channel = payload.channel;
  state.admin_teams_channels = payload.admin_teams_channels;
};

const onSignInFailed = (state, { error }) => {
  state.loading = false;
  state.error = error.message;
  state.success = null;
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetMessageState: (state) => {
      state.error = null;
      state.success = null;
    },
    signout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.permissions = null;
      state.actingOrganizationId = null;
    },
    updateToken: (state, { payload }) => {
      state.token = payload;
    },
    updateDefaultTeamChannel: (state, { payload }) => {
      state.team = payload.team;
      state.channel = payload.channel;
    },
  },
  extraReducers: {
    [signIn.pending]: (state) => {
      state.loading = true;
    },
    [signIn.fulfilled]: onSignedIn,
    [signIn.rejected]: onSignInFailed,
    [slackSignIn.pending]: (state) => {
      state.loading = true;
    },
    [slackSignIn.fulfilled]: onSignedIn,
    [slackSignIn.rejected]: onSignInFailed,
    [fetchMe.fulfilled]: (state, { payload }) => {
      state.admin = payload.admin;
      state.organization = payload.organization;
      state.permissions = payload.permissions;
    },
    [switchOrganization.fulfilled]: (state, { payload }) => {
      state.organization = payload.organization;
      state.actingOrganizationId = payload.organization.id;
      // What the admin may do depends on the organization they act in.
      state.permissions = payload.permissions;
      state.team = payload.team;
      state.channel = payload.channel;
      state.admin_teams_channels = payload.admin_teams_channels;
    },
    [fetchMe.rejected]: (state, { payload }) => {
      if (payload?.status === 401) {
        // Token no longer valid (e.g. admin was deactivated).
        state.isLoggedIn = false;
        state.token = null;
        state.permissions = null;
      } else if (!state.permissions) {
        // Couldn't load permissions: fail closed rather than spin forever.
        state.permissions = [];
      }
    },
  },
});

export const { resetMessageState, signout, updateDefaultTeamChannel, updateToken } =
  AuthSlice.actions;

export default AuthSlice.reducer;
